export default __webpack_public_path__ + "static/media/cross-grey.7a808653.svg";